
	import { Component, Prop, Vue } from 'vue-property-decorator';
	import Loading from '@/components/Loading.vue';

	@Component({
		components: { Loading }
	})
	export default class ErrorModal extends Vue {
		private classes: any;
		@Prop() private msg!: string;

		private restart() {
			this.$emit('ok');
		}
	}
